<template>
  <b-modal
    :no-close-on-backdrop="true"
    id="invoicedelete"
    size="md"
    body-class="bg-white"
    cancel-title="Cancel"
    cancel-variant="light"
    :ok-title-html="submitted==true?loaderIcon+'Yes':'Yes'"
    @ok="handledelete"
    title="Bulk Delete"
    ref="delete"
    :ok-disabled="submitted"
  >
    <p>{{ content }}</p>
  </b-modal>
</template>

<script>
export default {
  data() {
    return {
      loaderIcon: `<i class="fa fa-circle-o-notch fa-spin mr-2"></i>`,
      submitted: false
    };
  },
  props: ["content", "module", "value"],
  methods: {
    handledelete() {
      this.submitted = true;
      this.$store
        .dispatch(
          this.module + "/bulkdelete",
          JSON.stringify({
            delete_details: this.value
          })
        )
        .then(response => {
          this.$emit("setDelete", { response: response });
          this.$refs.delete.hide();
          this.submitted = false;
        });
    }
  }
};
</script>

<style>
</style>
